var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPptxIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1171 6.21063C11.1176 6.09392 11.0707 5.98202 10.987 5.90064C10.9034 5.81926 10.7902 5.77541 10.6736 5.77915C6.94958 6.00868 4 9.10149 4 12.8829C4 16.8137 7.18623 20 11.1171 20C14.8967 20 17.9882 17.0539 18.2204 13.333V13.3277C18.225 13.2107 18.1815 13.0969 18.0999 13.0128C18.0184 12.9288 17.906 12.8818 17.7889 12.8829H11.5623C11.3164 12.8829 11.1171 12.6849 11.1171 12.4381V6.21063Z",
    fill: "#F25123"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8965 10.6588C12.8965 10.9044 13.0944 11.1037 13.3413 11.1037H19.5688C19.6851 11.1046 19.7968 11.0581 19.8782 10.9749C19.9596 10.8918 20.0036 10.7791 20.0002 10.6628C20.0002 10.6628 20.0091 10.8087 20.0002 10.6628C19.7814 7.0874 16.9239 4.22545 13.3502 4.00082L13.3431 4.00037C13.2259 3.9955 13.1117 4.03889 13.0273 4.12042C12.943 4.20195 12.8957 4.3145 12.8965 4.43184V10.6584V10.6588Z",
    fill: "#F25123"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPptxIcon);
export default __webpack_public_path__ + "static/media/pptx-icon.9b43962d.svg";
export { ForwardRef as ReactComponent };